import { IContentTextTemplate } from '@dadohr/shared/domainTypes/experience';
import { SetStateAction } from 'react';
import { FormRow } from '../../../../../../../../components/Form/FormRow';
import { TokenDefinition } from '../../../../../../../../components/MarkdownText';
import { TextAlignToggleButtonGroupWithLabel } from '../../../../../../../../components/TextAlignToggleButtonGroup';
import { MarkdownEditorWithAI } from '../../../../components/AIContentGenerator/MarkdownEditorWithAI';
import { TaskBuilderContext } from '../../../types';
import {
  TaskBuilderBlockValidationState,
  TaskBuilderBlockValidationStateItem,
  useFieldValidator,
  VALIDATORS_TEXT
} from '../../../validation';

export const BlockSettingsContentText = ({
  value,
  onChange,
  validation,
  setValidation,
  expTpl,
  tokens,
  timelineItemId,
  timelineItemTitle,
  timelineItemType
}: {
  value: IContentTextTemplate;
  onChange: (nextValue: IContentTextTemplate) => void;
  validation: TaskBuilderBlockValidationStateItem | null;
  setValidation: React.Dispatch<
    SetStateAction<TaskBuilderBlockValidationState>
  >;
  expTpl: TaskBuilderContext;
  tokens: TokenDefinition[];
  timelineItemId?: string;
  timelineItemTitle?: string;
  timelineItemType?: 'task' | 'message';
}) => {
  const validateText = useFieldValidator(
    setValidation,
    VALIDATORS_TEXT,
    'text'
  );
  const invalidTextReason = validation?.fields.text || null;
  const textAlign = value.data.t.textAlign || 'left';
  return (
    <>
      <FormRow>
        <MarkdownEditorWithAI
          templateId={expTpl.templateId}
          templateName={expTpl.title}
          timelineItemId={timelineItemId}
          timelineItemType={timelineItemType}
          timelineItemTitle={timelineItemTitle}
          fullWidth
          value={value.data.t.t}
          key={textAlign}
          autoFocus
          onChange={(v, wasAIGenerated) => {
            const nextValue: IContentTextTemplate = Object.assign({}, value, {
              ...(wasAIGenerated || value.aiFeatureUsed
                ? { aiFeatureUsed: true }
                : {}),
              data: Object.assign({}, value.data, {
                t: Object.assign({}, value.data.t, {
                  ...value.data.t,
                  t: v
                })
              })
            });

            invalidTextReason && validateText(nextValue, expTpl);
            onChange(nextValue);
          }}
          tokens={tokens}
          error={!!invalidTextReason}
          helperText={invalidTextReason}
          onBlur={() => validateText(value, expTpl)}
          rows={12}
          textAlign={textAlign}
        />
      </FormRow>
      <FormRow>
        <TextAlignToggleButtonGroupWithLabel
          fullWidth
          value={value.data.t.textAlign || 'left'}
          onChange={(nextAlign) => {
            const nextValue: IContentTextTemplate = Object.assign({}, value, {
              data: Object.assign({}, value.data, {
                t: Object.assign({}, value.data.t, {
                  ...value.data.t,
                  textAlign: nextAlign
                })
              })
            });
            onChange(nextValue);
          }}
        />
      </FormRow>
    </>
  );
};

export const BlockSettingsContentTextReadOnly = ({
  value
}: {
  value: IContentTextTemplate;
}) => null;
